import { render, staticRenderFns } from "./PrmanentEmp.vue?vue&type=template&id=c87497ae"
import script from "./PrmanentEmp.vue?vue&type=script&lang=js"
export * from "./PrmanentEmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports